export default __webpack_public_path__ + "static/media/DIY09.448fcbc3.JPG";